import { useMemo } from 'react';
import { useEntityCollectionInitializer } from 'store/entityCollection';
import { useIssueFormStore } from '../store';
import type { UseIssueFormResult } from '../types';

export function useIssueFormInitializer(): void {
  useEntityCollectionInitializer(useIssueFormStore.use.actions());
}

export function useIssueForm(): UseIssueFormResult {
  const { items } = useIssueFormStore.use.data();
  return useMemo(() => ({ issueForm: items }), [items]);
}

export function useIssueFormLoading(): boolean {
  return useIssueFormStore.use.data().loading;
}
